import React from "react";

type ShareIconProps = {
    className?: string;
};

const ShareIcon: React.FC<ShareIconProps> = ({className = "size-4 fill-gray-600"}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 15.43 15.43"
            className={className}
        >
            <path
                // fill="#8b8989"
                d="M12.34,15.43c-1.7,0-3.09-1.38-3.09-3.09,0-.22.02-.44.07-.65l-3.91-1.96c-.57.65-1.4,1.06-2.33,1.06-1.7,0-3.09-1.38-3.09-3.09s1.38-3.09,3.09-3.09c.93,0,1.76.41,2.33,1.06l3.91-1.96c-.04-.21-.07-.42-.07-.65,0-1.7,1.38-3.09,3.09-3.09s3.09,1.38,3.09,3.09-1.38,3.09-3.09,3.09c-.93,0-1.76-.41-2.33-1.06l-3.91,1.96c.04.21.07.42.07.65s-.02.44-.07.65l3.91,1.96c.57-.65,1.4-1.06,2.33-1.06,1.7,0,3.09,1.38,3.09,3.09s-1.38,3.09-3.09,3.09ZM12.34,10.8c-.85,0-1.54.69-1.54,1.54s.69,1.54,1.54,1.54,1.54-.69,1.54-1.54-.69-1.54-1.54-1.54ZM3.09,6.17c-.85,0-1.54.69-1.54,1.54s.69,1.54,1.54,1.54,1.54-.69,1.54-1.54-.69-1.54-1.54-1.54ZM12.34,1.54c-.85,0-1.54.69-1.54,1.54s.69,1.54,1.54,1.54,1.54-.69,1.54-1.54-.69-1.54-1.54-1.54Z"
            />
        </svg>
    );
};

export default ShareIcon;
